//ALERT
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

//AUTHENTICATION
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const ADMIN_LOADED = 'ADMIN_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_USER = 'CLEAR_USER';

//STUDENT
export const GET_STUDENTS = 'GET_STUDENTS';
export const STUDENT_ERROR = 'STUDENT_ERROR';

//COMPLAINT
export const ADD_COMPLAINT = 'ADD_COMPLAINT';
export const COMPLAINT_ERROR = 'COMPLAINT_ERROR';
export const GET_MY_COMPLAINTS = 'GET_MY_COMPLAINTS';
export const DELETE_COMPLAINT = 'DELETE_COMPLAINT';
export const CLEAR_COMPLAINTS = 'CLEAR_COMPLAINTS';
export const GET_COMPLAINTS = 'GET_COMPLAINTS';
export const UPDATE_COMPLAINT = 'UPDATE_COMPLAINT';

//APPLICATION
export const ADD_APPLICATION = 'ADD_APPLICATION';
export const APPLICATION_ERROR = 'APPLICATION_ERROR';
export const GET_MY_APPLICATION = 'GET_MY_APPLICATION';
export const GET_APPLICATIONS = 'GET_APPLICATIONS';
export const DELETE_APPLICATION = 'DELETE_APPLICATION';
export const CLEAR_APPLICATION = 'CLEAR_APPLICATION';
export const APPROVE_APPLICATION = 'APPROVE_APPLICATION';
export const REJECT_APPLICATION = 'REJECT_APPLICATION';
export const VERIFY_APPLICATION = 'VERIfY_APPLICATION';
export const ALLOT_APPLICATION = 'ALLOT_APPLICATION';
export const UNALLOT_APPLICATION = 'UNALLOT_APPLICATION';

//HOSTEL
export const GET_HOSTELS = 'GET_HOSTELS';
export const DELETE_HOSTEL = 'DELETE_HOSTEL';
export const ADD_HOSTEL = 'ADD_HOSTEL';
export const HOSTEL_ERROR = 'HOSTEL_ERROR';

//ROOM
export const GET_MY_ROOM = 'GET_MY_ROOM';
export const GET_ROOMS = 'GET_ROOMS';
export const DELETE_ROOM = 'DELETE_ROOM';
export const ADD_ROOM = 'ADD_ROOM';
export const ROOM_ERROR = 'ROOM_ERROR';
export const REMOVE_STUDENT = 'REMOVE_STUDENT';

//NOTICE
export const GET_NOTICES = 'GET_NOTICES';
export const ADD_NOTICE = 'ADD_NOTICE';
export const NOTICE_ERROR = 'NOTICE_ERROR';
export const DELETE_NOTICE = 'DELETE_NOTICE';
export const DOWNLOAD_NOTICE = 'DOWNLOAD_NOTICE';

//FEE
export const GET_KEY = 'GET_KEY';
export const CHECKOUT = 'CHECKOUT';
export const RECEIPT = 'RECEIPT';
export const FEE_ERROR = 'FEE_ERROR';
export const LOAD_RECEIPTS = 'LOAD_RECEIPTS';
export const GET_FEES = 'GET_FEES';